import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import moment from "moment";
//Icons
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { GET_REQ_PURCHASE_PAGINATION } from "../Schema/Reqpurchase";
import EmptyData from "../Components/Include/EmptyData";
import CreateIcon from "../Assets/create-icon.svg";
import CreateReqPurchase from "../Components/ReqPurchase/CreateReqPurchase";
import { AuthContext } from "../Context/AuthContext";
import ReqPurchaseAction from "../Components/ReqPurchase/ReqPurchaseAction";
import ButtonStatus from "../Components/ReqPurchase/ButtonStatusAction";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getInvoiceNo } from "../Function/FnKhmernumber";

export default function ReqPurchase() {
  // 
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState(0);
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [priority, setPriority] = useState("All");
  const [status, setStatus] = useState("All");
  const [date, setDate] = useState("");
  // console.log("tableData", tableData);
 

  const { refetch } = useQuery(GET_REQ_PURCHASE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      no: keyword,
      pagination: true,
      priority: priority,
      date: date ? moment(date).format("YYYY-MM-DD") : "",
      status: status,
    },
    onCompleted: ({ getReqPurchasePagination }) => {
      setTableData(getReqPurchasePagination?.data);
      setPaginationData(getReqPurchasePagination?.paginator);
      setLoading(false);
      // console.log("first::", getReqPurchasePagination?.data);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect( () => {
    refetch();
    setLoading(true);
  },[
    keyword,
    priority,
    date,
    status,
  ])

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          {/* <Link className="page-link-title" to="/setting"> */}
          <Typography className="page-title">ការស្នើរទិញ</Typography>
          {/* </Link> */}
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              type="number"
              placeholder="ស្វែងរកឈ្មោះអ្នកប្រើប្រាស់"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value="Approved">បានអនុម័ត</MenuItem>
                <MenuItem value="Rejected">បានបដិសេធ</MenuItem>
                <MenuItem value="Purchase">បានបញ្ជាទិញ</MenuItem>
                <MenuItem value="InStock">បានទទួល</MenuItem>
                <MenuItem value="Voided">បានមោឃៈ</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">កាលបរិច្ចេទ</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={date}
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                className="search-field"
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={6} md={12} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
          {
            open && 
            <CreateReqPurchase
              dialogTitle="Create"
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
            />
          } 
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="8%">
                ល.រ
              </TableCell>
              <TableCell className="header-title" width="13%">
                កាលបរិច្ចេទ
              </TableCell>
              <TableCell className="header-title" width="10%">
                អាទិភាព
              </TableCell>
              <TableCell className="header-title" width="15%">
                អ្នកផ្គត់ផ្គង់
              </TableCell>
              <TableCell className="header-title" width="5%">
                អ្នកស្នើ
              </TableCell>
              <TableCell className="header-title" align="center" width="18%">
                ស្ថានភាព
              </TableCell>
              <TableCell className="header-title" width="17%">
                ផ្សេងៗ
              </TableCell>
              <TableCell className="header-title-end" width="14%"></TableCell>
            </TableHead>

            {loading ? (
              <LoadingPage colSpan={8} />
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <EmptyData colSpan={8} />
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start">
                            {getInvoiceNo(row?.no)}
                          </TableCell>
                          <TableCell className="body-cell">
                            {moment(row?.createdAt).format("DD-MM-YYYY hh A")}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.priority}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.supplierId?.name}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.createdBy?.mainUserId?.firstName +
                              " " +
                              row?.createdBy?.mainUserId?.lastName}
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            {row?.voidBy === null ? (
                              <Chip
                                size="small"
                                sx={{
                                  width: "80px",
                                  fontSize: "14px !important",
                                  color:
                                    row?.status === "Approved"
                                      ? "#4caf50"
                                      : row?.status === "Rejected"
                                      ? "#f44336"
                                      : row?.status === "Received"
                                      ? "#0091ea"
                                      : row?.status === "Pending"
                                      ? "#ffab40"
                                      : "#9c27b0",
                                  bgcolor:
                                    row?.status === "Approved"
                                      ? "#e8f5e9"
                                      : row?.status === "Rejected"
                                      ? "#ffebee"
                                      : row?.status === "Received"
                                      ? "#e1f5fe"
                                      : row?.status === "Pending"
                                      ? "#ffecb3"
                                      : "#f3e5f5",
                                }}
                                label={row?.status}
                              />
                            ) : (
                              <Chip
                                size="small"
                                label="Void"
                                sx={{
                                  width: "80px",
                                  fontSize: "14px !important",
                                  color: "red",
                                  bgcolor: "rgba(255, 0, 0, 0.1)", // Light red background
                                }}
                              />
                            )}

                            {/* <ButtonStatus editData={row} setRefetch={refetch} /> */}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <ReqPurchaseAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
      </Box>
    </div>
  );
}
